import { useAddUserRoles } from './useAddUserRoles';
import { useBulkImport } from './useBulkImport';
import { useCreateMacl } from './useCreateMacl';
import { useCreateReport } from './useCreateReport';
import { useCreateUser } from './useCreateUser';
import { useEditMacl } from './useEditMacl';
import { useGetBanners } from './useGetBanners';
import { useGetMacls } from './useGetMacls';
import { useGetReports } from './useGetReports';
import { useGetRoleEntities } from './useGetRoleEntities';
import { useGetUser } from './useGetUser';
import { useGetUserRoles } from './useGetUserRoles';
import { useGetUsers } from './useGetUsers';
import { useRemoveBanner } from './useRemoveBanner';
import { useRemoveExternalAccount } from './useRemoveExternalAccount';
import { useRemoveMacl } from './useRemoveMacl';
import { useRemoveUserRole } from './useRemoveUserRole';
import { useSendWelcomeEmail } from './useSendWelcomeEmail';
import { useSetReportYearDates } from './useSetReportYearDates';
import { useStoreBanner } from './useStoreBanner';
import { useUpdateUser } from './useUpdateUser';
import { useUpdateUserRole } from './useUpdateUserRole';

export const adminServiceEvents = {
    user_created: 'AdminService.createUser',
    user_updated: 'AdminService.updateUser',
    banner_list_updated: 'AdminService.updatedBanners',
    macl_list_updated: 'AdminService.updateMacl',
    report_list_updated: 'AdminService.updatedReports',
    welcome_email_sent: 'AdminService.sendWelcomeEmail',
    user_organization_added: 'AdminService.addUserOrganizations',
    user_macl_added: 'AdminService.addUserMacls',
    user_market_added: 'AdminService.addUserMarkets',
    user_organization_updated: 'AdminService.updateOrganizationUser',
    user_macl_updated: 'AdminService.updateMaclUser',
    user_market_updated: 'AdminService.updateMarketUser',
    user_organization_removed: 'AdminService.removeOrganizationUser',
    user_macl_removed: 'AdminService.removeMaclUser',
    user_market_removed: 'AdminService.removeMarketUser',
};
export type AdminServiceEvents = typeof adminServiceEvents;

export const useAdminService = () => {
    const getBanners = useGetBanners();
    const storeBanner = useStoreBanner(adminServiceEvents);
    const removeBanner = useRemoveBanner(adminServiceEvents);
    const getMacls = useGetMacls();
    const createMacl = useCreateMacl(adminServiceEvents);
    const editMacl = useEditMacl(adminServiceEvents);
    const removeMacl = useRemoveMacl(adminServiceEvents);
    const getReports = useGetReports();
    const createReport = useCreateReport(adminServiceEvents);
    const bulkImport = useBulkImport();
    const sendWelcomeEmail = useSendWelcomeEmail(adminServiceEvents);
    const removeExternalAccount = useRemoveExternalAccount(adminServiceEvents);
    const getUser = useGetUser();
    const getUsers = useGetUsers();
    const createUser = useCreateUser(adminServiceEvents);
    const updateUser = useUpdateUser(adminServiceEvents);
    const getUserRoles = useGetUserRoles();
    const { getRoleEntities, getCachedMarkets } = useGetRoleEntities();
    const addUserRoles = useAddUserRoles(adminServiceEvents);
    const updateUserRole = useUpdateUserRole(adminServiceEvents);
    const removeUserRole = useRemoveUserRole(adminServiceEvents);
    const setReportYearDates = useSetReportYearDates();

    return {
        events: adminServiceEvents,
        getBanners,
        storeBanner,
        removeBanner,
        getMacls,
        createMacl,
        editMacl,
        removeMacl,
        getReports,
        createReport,
        bulkImport,
        sendWelcomeEmail,
        removeExternalAccount,
        getUser,
        getUsers,
        createUser,
        updateUser,
        getUserRoles,
        getRoleEntities,
        getCachedMarkets,
        addUserRoles,
        updateUserRole,
        removeUserRole,
        setReportYearDates,
    };
};
